import { PageLoader } from '@/layouts/components/PageLoader/PageLoader';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { routes } from '../routes';
import { useLoan, type LoanContractSummary } from '@/features/loan';
import type { ApplicationState } from '@/features/application';
import { useApplication } from '@/features/application/hooks';

export const LoanGuard = () => {
  const location = useLocation();
  const { activeLoanSummary, isLoading: isLoanLoading } = useLoan(true);
  const { applicationState, isApplicationStateLoading } = useApplication(true);

  if (isLoanLoading || isApplicationStateLoading) {
    return <PageLoader />;
  }

  const nextStep = getNextLoanStep(activeLoanSummary, applicationState);
  if (location.pathname !== nextStep) {
    return <Navigate to={nextStep} replace />;
  }

  return <Outlet />;
};

const getNextLoanStep = (
  activeLoanSummary: LoanContractSummary | null | undefined,
  application: ApplicationState | undefined
) => {
  if (activeLoanSummary) {
    return routes.loan.active;
  }

  if (
    application?.contractStatus === 'Draft' ||
    application?.contractStatus === 'ReadyForSign'
  ) {
    return routes.loan.sign;
  }

  return routes.wizard.base;
};
